import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { Link } from "react-router-dom";
import "./Benefits.scss";

const Benefits = ({ data, isMember}) => {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="benefits">
      <div className="img-container">
        <img src="images/modal.png"/>
      </div>
      <div className="benefits-title">{isMember?  data.featurePaymentTitle : data.featureTitle}</div>
      <ul className="benefit-list">
      { data.features.map((feature, rowIndex) => (
          <li key={`feature-${rowIndex}`} className="benefit-item">
            <p className="benefit-text">
              <IoMdCheckmark size={15} className="benefit-icon" />
              &nbsp;{feature}
            </p>
          </li>
        ))}
      </ul>
      <div className="continue">
        <Link to="/membership" target="_blank">{isMember ? data.pay : data.continue}</Link>
      </div>
    </div>
  );
};

export default Benefits;
